import feeds from './feeds/feeds';
import webshops from './webshops/webshops';
import connections from './connections/connections';

const clients = {
    'clients.add': 'Klant uitnodigen',
    'clients.add.explanation': 'Voer een bedrijfsnaam en contactpersoon in om een uitnodiging te versturen.',

    'client.attention.needed': 'Aandacht nodig',

    'clients.company': 'Mijn bedrijf',

    'clients.company.subscription': 'Abonnement',
    'clients.company.subscription.plan': 'Abonnement plan',

    'clients.company.subscription.choose.option': 'Kies deze optie',

    'clients.company.subscription.type.yearly': 'Jaarlijks',
    'clients.company.subscription.type.once': 'Eenmalig',
    'clients.company.subscription.type.free': 'Gratis',

    'clients.company.subscription.payment_interval': 'Betaald per',
    'clients.company.subscription.payment_interval.year': 'Jaar',
    'clients.company.subscription.payment_interval.yearly': 'Jaar',
    'clients.company.subscription.payment_interval.month': 'Maand',
    'clients.company.subscription.payment_interval.monthly': 'Maand',
    'clients.company.subscription.payment_interval.once': 'Eenmalig',
    'clients.company.subscription.payment_interval.free': 'n.v.t.',

    'clients.company.subscription.yearly.description': 'Actief voor 1 jaar. Kies je eigen bereik van producten. (Prijs per maand excl. Btw)',
    'clients.company.subscription.once.description': 'Actief voor 1 week. Kies je eigen bereik van producten. (Prijs excl. Btw)',
    'clients.company.subscription.free.description': 'Demo versie. Actief voor 1 week tot maximaal 10 producten.',

    'clients.subscription.payment_plan': 'Betaalplan',
    'clients.subscription.upcoming_payment_plan': 'Aankomend betaalplan',
    'clients.subscription.days_valid': 'Dagen actief',
    'clients.subscription.max_sync': 'Max aantal producten',
    'clients.subscription.update_payment_plan': 'Bewerk betaalplan',
    'clients.subscription.cancel_payment_plan': 'Annuleer betaalplan',
    'clients.subscription.cancel_payment_plan_not_possible': 'Annuleren is niet mogelijk gezien de betaling al is verwerkt.',
    'clients.subscription.valid_till_today': 'Tot vandaag',
    'clients.subscription.expired': 'Verlopen',
    'clients.subscription.start_date': 'Ingangsdatum',
    'clients.subscription.end_date': 'Einddatum',

    'clients.pricing.explanation': 'Hier pas je de bestaande bruto prijs zonder korting aan. Bestaande B2B prijzen en eventuele B2B kortingen blijven gelden.',
    'clients.notation.explanation': 'Dit is om aan te geven of er punten of komma\'s\ worden gebruikt in de prijs. Voorbeeld : €12,34',

    ...feeds,
    ...webshops,
    ...connections,
};

export default clients;
